export default "__VITE_ASSET__BcFEzQgW__"